export const WISHLIST_BASE_FILTERS = '{ deletedAt: null } { isActive: true }';
